import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IApoyo } from '../models/apoyo';
import { ICiudadPrincipalHM } from '../models/ciudadprincipal';
import { CiudadesprincipalesService } from './ciudadesprincipales.service';
import { ICatApoyo } from '../models/catapoyos';
import { InombreCompletoChoferciudadprincipal } from '../models/nombrecompletociudadprincipal';
import { IPostApoyo } from '../models/postapoyo';
import { IsalarioPromedio } from '../models/salariopromedio';
import { IValeDespensa } from '../models/valedespensa';

@Injectable({
  providedIn: 'root'
})
export class Valedespensaservice{

  private apiUrl: string = environment.sUrlNomina + 'ValeDespensa';

  constructor(private http: HttpClient, private ciudadesPrincipalesService: CiudadesprincipalesService) { }  // Inyección de CiudadesprincipalesService


 getListvales(num_anio: number,id_semana:number,num_mes_filtro:number ,id_ciudad_hm: number): Observable<IValeDespensa[]> {
  const valores = {
    params: new HttpParams().
       set('num_anio',num_anio).
       set('id_semana',id_semana).
       set('num_mes_filtro',num_mes_filtro).
       set('id_ciudad_hm',id_ciudad_hm)

  }
  return this.http
      .get<IValeDespensa[]>(this.apiUrl +'/getvaledesp',valores)
      .pipe(retry(1), catchError(this.handleError));

 }

 getrptvalesdespensa(num_anio: number,num_mes_rpt:number ,id_ciudad_hm: number): Observable<any[]> {
  const valores = {
    params: new HttpParams().
       set('num_anio',num_anio).
       set('num_mes_rpt',num_mes_rpt).
       set('id_ciudad_hm',id_ciudad_hm)

  }
  return this.http
      .get<any[]>(this.apiUrl +'/rptvaledespensa',valores)
      .pipe(retry(1), catchError(this.handleError));

 }
public postValeDespensa(data: any):Observable<any>{
  const headers = { 'content-type': 'application/json'}
  const body = JSON.stringify(data);
  return this.http.post<any>(this.apiUrl + '/Agregavale/',body,{'headers':headers});
 }

 public deleteValeDespensa(data: any):Observable<any>{
  const headers = { 'content-type': 'application/json'}
  const body = JSON.stringify(data);
  return this.http.post<any>(this.apiUrl + '/delteval/',body,{'headers':headers});
 }



  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }

}
